import { render, staticRenderFns } from "./CheckoutCalculator.vue?vue&type=template&id=5a980332&scoped=true"
import script from "./CheckoutCalculator.vue?vue&type=script&lang=js"
export * from "./CheckoutCalculator.vue?vue&type=script&lang=js"
import style0 from "./CheckoutCalculator.vue?vue&type=style&index=0&id=5a980332&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a980332",
  null
  
)

export default component.exports